<div class="container">
    <div class="row">
        <div class="col-12 col-md-6 col-lg-6">
            <div class="float-start">
                <h3 class="ff-medium text-uppercase fw-semibold fs-6 py-3">Taller</h3>
                <div class="row">
                    <ul class="list-unstyled">
                        <li class="mb-2">
                            <a routerLink="/servicio-tecnico/agendar-cita" class="text-uppercase ff-medium" (click)="cerrarMenu()">Agendar Cita</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div style="border-left: 1px solid #000; height: 100px;" class="float-end mb-4"></div>
        </div>
        <div class="col-12 col-md-6 col-lg-6">
            <div class="float-start">
                <h3 class="ff-medium text-uppercase fw-semibold fs-6 py-3">Repuestos</h3>
                <div class="row">
                    <ul class="list-unstyled">
                        <li class="mb-2">
                            <a href="https://www.toyosa.com/tienda-virtual/repuestos/yamaha" target="_blank" class="text-uppercase ff-medium" (click)="cerrarMenu()">Tienda en línea</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
